import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    unit: null,
    units: [],
    unitWindows: [],
    unitSchedules: [],
    unitErrors: null,
    unitFilters: null,
    unitTypesFilter: [],
    unitNeighbours: [],
    unitNeighboursLoad: false,
    unitTypes: [],
    searchStores: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
